import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AllServicesLayer from "../../components/service-catalog/AllServicesLayer";

const AllServicesPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb
          routePath="/service-catalog"
          routeName="Home"
          title="Service Catalog"
        />
        <AllServicesLayer />
      </MasterLayout>
    </>
  );
};

export default AllServicesPage;
